import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { CustomSvgIconName } from '@panaya/ui/p-icon/customize';
import { DefaultTo } from '@panaya/utils';
import { DefaultIconSize } from '../defaults';
import { injectPIconConfig } from '../p-icon-config.provider';
import type { SvgIconName } from '../svg-icons';
import type { IconSize } from '../types';

@Component({
    selector: 'p-icon-image',
    templateUrl: './p-icon-image.component.html',
    styleUrls: ['./p-icon-image.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'pIcon'
})
export class PIconImageComponent {
    // TODO(Angular 16+): Use required inputs and remove the `!` sign
    @Input() public name!: SvgIconName | CustomSvgIconName;
    @Input() @DefaultTo(DefaultIconSize) public size!: IconSize;

    protected readonly config = injectPIconConfig();

    protected get iconPath(): string {
        return `${this.config.svgIconsOutputFolder}/${this.name}.svg`;
    }
}
